<template>
  <div class="py-4 container-fluid">
    <div class="row">
      <div class="col-lg-4 order-lg-1 order-2">
        <div class="card mb-4">
          <div class="card-header pb-0">
            <div class="d-flex justify-content-between align-items-center">
              <h6 class="mb-0">Agregar bodegas al plano</h6>
              <button class="btn btn-outline-secondary btn-sm" type="button" @click="resetForm">
                Limpiar
              </button>
            </div>
          </div>
          <div class="card-body">
            <form @submit.prevent="addElement">
              <div class="mb-3">
                <label class="form-label text-sm">Bodega</label>
                <select ref="bodegaSelect" class="form-control" required>
                  <option value="">Selecciona una bodega</option>
                  <option v-for="bodega in bodegas" :key="bodega.id" :value="bodega.id">
                    {{ bodega.name }} ({{ bodega.code }})
                  </option>
                </select>
                <small v-if="selectedBodega" class="text-muted d-block mt-1">
                  Stock total: <strong>{{ selectedBodega.stock_total ?? 0 }}</strong>
                </small>
              </div>

              <div class="mb-3">
                <label class="form-label text-sm">Etiqueta visible</label>
                <input type="text" class="form-control" v-model="form.label" maxlength="25" />
                <small class="text-muted">Por defecto se usa el código de la bodega.</small>
              </div>

              <div class="mb-3">
                <label class="form-label text-sm">Tipo de figura</label>
                <div class="btn-group w-100">
                  <button type="button" class="btn" :class="form.shape === 'rectangle' ? 'btn-primary' : 'btn-outline-primary'"
                    @click="form.shape = 'rectangle'">
                    Rectángulo
                  </button>
                  <button type="button" class="btn" :class="form.shape === 'circle' ? 'btn-primary' : 'btn-outline-primary'"
                    @click="form.shape = 'circle'">
                    Círculo
                  </button>
                </div>
              </div>

              <div class="row">
                <div class="col-6" v-if="form.shape === 'rectangle'">
                  <div class="mb-3">
                    <label class="form-label text-sm">Ancho (px)</label>
                    <input type="number" class="form-control" v-model.number="form.width" min="30" max="400" />
                  </div>
                </div>
                <div class="col-6" v-if="form.shape === 'rectangle'">
                  <div class="mb-3">
                    <label class="form-label text-sm">Alto (px)</label>
                    <input type="number" class="form-control" v-model.number="form.height" min="30" max="400" />
                  </div>
                </div>
                <div class="col-12" v-else>
                  <div class="mb-3">
                    <label class="form-label text-sm">Diámetro (px)</label>
                    <input type="number" class="form-control" v-model.number="form.diameter" min="40" max="280" />
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-6">
                  <div class="mb-3">
                    <label class="form-label text-sm">Posición X (px)</label>
                    <input type="number" class="form-control" v-model.number="form.posX" min="0" max="1000" />
                  </div>
                </div>
                <div class="col-6">
                  <div class="mb-3">
                    <label class="form-label text-sm">Posición Y (px)</label>
                    <input type="number" class="form-control" v-model.number="form.posY" min="0" max="600" />
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-6">
                  <div class="mb-3">
                    <label class="form-label text-sm">Color de fondo</label>
                    <input type="color" class="form-control form-control-color" v-model="form.background" />
                  </div>
                </div>
                <div class="col-6">
                  <div class="mb-3">
                    <label class="form-label text-sm">Color de texto</label>
                    <input type="color" class="form-control form-control-color" v-model="form.textColor" />
                  </div>
                </div>
              </div>

              <div class="mb-3">
                <label class="form-label text-sm">Color del borde</label>
                <input type="color" class="form-control form-control-color" v-model="form.borderColor" />
              </div>

              <button class="btn btn-primary w-100" type="submit" :disabled="!canAddElement">
                Agregar al plano
              </button>
            </form>
          </div>
        </div>

        <div class="card">
          <div class="card-header pb-0">
            <h6 class="mb-0">Elementos creados ({{ mapElements.length }})</h6>
          </div>
          <div class="card-body p-0">
            <ul class="list-group list-group-flush">
              <li v-if="!mapElements.length" class="list-group-item text-muted small">
                Aún no hay bodegas en el plano dinámico.
              </li>
              <li class="list-group-item d-flex justify-content-between align-items-center gap-2"
                v-for="element in mapElements" :key="element.id">
                <div class="flex-grow-1">
                  <strong>{{ element.label }}</strong>
                  <div class="text-muted small">
                    {{ element.shape === 'circle' ? 'Círculo' : 'Rectángulo' }} · Posición ({{ element.posX }}, {{
                      element.posY }})
                  </div>
                </div>
                <button class="btn btn-link text-danger text-sm" type="button" @click="removeElement(element.id)">
                  <i class="fas fa-trash"></i>
                </button>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div class="col-lg-8 order-lg-2 order-1">
        <div class="card h-100">
          <div class="card-header pb-0 d-flex justify-content-between align-items-center flex-wrap gap-2">
            <div>
              <h6 class="mb-0">Plano dinámico</h6>
              <small class="text-muted">Haz clic sobre las figuras para ver el detalle de la bodega.</small>
            </div>
            <div class="d-flex gap-3 align-items-center flex-wrap">
              <div class="d-flex align-items-center gap-1">
                <span class="legend legend-occupied"></span>
                <small>Ocupado</small>
              </div>
              <div class="d-flex align-items-center gap-1">
                <span class="legend legend-available"></span>
                <small>Disponible</small>
              </div>
              <div class="d-flex align-items-center gap-1">
                <span class="legend legend-unassigned"></span>
                <small>Sin asignar</small>
              </div>
            </div>
          </div>
          <div class="card-body">
            <div class="factory-container" ref="factoryContainer">
              <p v-if="!mapElements.length" class="text-center text-muted mt-5">
                Usa el formulario para agregar bodegas al plano.
              </p>
              <div v-for="element in mapElements" :key="element.id" class="factory-section"
                :class="['dynamic', getStatusClass(element), { 'dragging': draggingElementId === element.id }]" 
                :style="getElementStyle(element)"
                @mousedown="startDrag($event, element.id)"
                @click="handleElementClick($event, element.bodegaCode)">
                <span>{{ element.label }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="modal fade" id="modalDetails" tabindex="-1" aria-labelledby="dynamicMapModalLabel" aria-hidden="true">
      <div class="modal-dialog modal-lg">
        <div class="modal-content card">
          <div class="modal-header">
            <h5 class="modal-title" id="dynamicMapModalLabel">
              Detalles de bodega - Stock total: {{ details?.stock_total ?? 0 }}
            </h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <table class="table" v-if="details?.bodegas_inventory?.length">
              <thead>
                <tr>
                  <th>Nombre de Inventario</th>
                  <th class="text-center">Cantidad</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="item in details.bodegas_inventory" :key="item.id">
                  <td>{{ item.inventory.name }}</td>
                  <td class="text-center">{{ item.quantity }}</td>
                </tr>
              </tbody>
            </table>
            <p v-else class="text-muted text-center mb-0">No hay inventarios asociados.</p>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" @click="closeModalDetails">Cerrar</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Modal } from 'bootstrap';
import $ from 'jquery';
import 'select2/dist/css/select2.css';
import 'select2';

const STORAGE_KEY = 'mistock.dynamic-map-elements';

export default {
  name: 'MapDesigner',
  data() {
    return {
      bodegas: [],
      mapElements: [],
      modalDetails: null,
      details: null,
      draggingElementId: null,
      dragOffset: { x: 0, y: 0 },
      form: {
        bodegaId: '',
        label: '',
        shape: 'rectangle',
        width: 120,
        height: 80,
        diameter: 80,
        posX: 60,
        posY: 60,
        background: '#495057',
        textColor: '#ffffff',
        borderColor: '#6c757d'
      }
    };
  },
  computed: {
    selectedBodega() {
      return this.bodegas.find(bodega => bodega.id === this.form.bodegaId) || null;
    },
    canAddElement() {
      return Boolean(this.form.bodegaId);
    }
  },
  watch: {
    'form.bodegaId'(value) {
      if (!value) {
        return;
      }
      const selected = this.selectedBodega;
      if (selected) {
        this.form.label = selected.code;
      }
    }
  },
  methods: {
    async getBodegas() {
      this.bodegas = await this.$store.dispatch('bodegas/getAll');
      
      // Inicializar select2 después de cargar las bodegas
      this.$nextTick(() => {
        this.initializeBodegaSelect();
      });
    },
    initializeBodegaSelect() {
      const $select = $(this.$refs.bodegaSelect);
      
      // Destruir select2 si ya está inicializado
      if ($select.hasClass("select2-hidden-accessible")) {
        $select.select2('destroy');
      }
      
      // Limpiar y agregar las opciones
      $select.empty().append('<option value="">Selecciona una bodega</option>');
      this.bodegas.forEach(bodega => {
        $select.append(new Option(`${bodega.name} (${bodega.code})`, bodega.id));
      });
      
      // Inicializar select2
      $select.select2({
        placeholder: 'Selecciona una bodega',
        allowClear: true,
        width: '100%'
      });
      
      // Actualizar el v-model cuando cambie el select2
      $select.on('change', () => {
        const selectedValue = $select.val();
        this.form.bodegaId = selectedValue ? parseInt(selectedValue) : '';
      });
      
      // Si hay un valor pre-seleccionado, establecerlo
      if (this.form.bodegaId) {
        $select.val(this.form.bodegaId).trigger('change');
      }
    },
    resetForm() {
      this.form = {
        bodegaId: '',
        label: '',
        shape: 'rectangle',
        width: 120,
        height: 80,
        diameter: 80,
        posX: 60,
        posY: 60,
        background: '#495057',
        textColor: '#ffffff',
        borderColor: '#6c757d'
      };
      
      // Limpiar el select2
      if (this.$refs.bodegaSelect) {
        $(this.$refs.bodegaSelect).val(null).trigger('change');
      }
    },
    addElement() {
      if (!this.selectedBodega) {
        return;
      }
      const newElement = {
        id: Date.now(),
        bodegaId: this.selectedBodega.id,
        bodegaCode: this.selectedBodega.code,
        label: this.form.label || this.selectedBodega.code,
        shape: this.form.shape,
        width: this.form.width,
        height: this.form.height,
        diameter: this.form.diameter,
        posX: this.form.posX,
        posY: this.form.posY,
        background: this.form.background,
        textColor: this.form.textColor,
        borderColor: this.form.borderColor
      };
      this.mapElements.push(newElement);
      this.persistElements();
    },
    removeElement(id) {
      this.mapElements = this.mapElements.filter(element => element.id !== id);
      this.persistElements();
    },
    getElementStyle(element) {
      const dimension = element.shape === 'circle' ? element.diameter : null;
      return {
        position: 'absolute',
        top: `${element.posY}px`,
        left: `${element.posX}px`,
        width: element.shape === 'circle' ? `${dimension}px` : `${element.width}px`,
        height: element.shape === 'circle' ? `${dimension}px` : `${element.height}px`,
        borderRadius: element.shape === 'circle' ? '50%' : '4px',
        backgroundColor: element.background,
        border: `2px solid ${element.borderColor}`,
        color: element.textColor
      };
    },
    getStatusClass(element) {
      const related = this.bodegas.find(bodega => bodega.code === element.bodegaCode);
      if (!related) {
        return 'status-unassigned';
      }
      if ((related.stock_total ?? 0) > 0) {
        return 'status-occupied';
      }
      return 'status-available';
    },
    openModalDetails(code) {
      this.details = this.bodegas.find(bodega => bodega.code === code) || null;
      if (!this.details) {
        return;
      }
      const modalElement = document.getElementById('modalDetails');
      this.modalDetails = new Modal(modalElement);
      this.modalDetails.show();
    },
    closeModalDetails() {
      if (this.modalDetails) {
        this.modalDetails.hide();
      }
    },
    persistElements() {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(this.mapElements));
    },
    restoreElements() {
      const stored = localStorage.getItem(STORAGE_KEY);
      if (stored) {
        try {
          this.mapElements = JSON.parse(stored);
        } catch (error) {
          console.error('No fue posible leer los elementos del mapa dinámico', error);
        }
      }
    },
    startDrag(event, elementId) {
      event.preventDefault();
      const element = this.mapElements.find(el => el.id === elementId);
      if (!element) return;

      const container = this.$refs.factoryContainer;
      if (!container) return;

      const elementRect = event.currentTarget.getBoundingClientRect();

      this.draggingElementId = elementId;
      this.dragOffset = {
        x: event.clientX - elementRect.left,
        y: event.clientY - elementRect.top
      };

      document.addEventListener('mousemove', this.onDrag);
      document.addEventListener('mouseup', this.stopDrag);
    },
    onDrag(event) {
      if (!this.draggingElementId) return;

      const container = this.$refs.factoryContainer;
      if (!container) return;

      const containerRect = container.getBoundingClientRect();
      const newX = event.clientX - containerRect.left - this.dragOffset.x;
      const newY = event.clientY - containerRect.top - this.dragOffset.y;

      // Limitar dentro de los bounds del contenedor
      const element = this.mapElements.find(el => el.id === this.draggingElementId);
      if (!element) return;

      const elementWidth = element.shape === 'circle' ? element.diameter : element.width;
      const elementHeight = element.shape === 'circle' ? element.diameter : element.height;

      const maxX = containerRect.width - elementWidth;
      const maxY = containerRect.height - elementHeight;

      element.posX = Math.max(0, Math.min(newX, maxX));
      element.posY = Math.max(0, Math.min(newY, maxY));
    },
    stopDrag() {
      if (this.draggingElementId) {
        this.persistElements();
        this.draggingElementId = null;
        this.dragOffset = { x: 0, y: 0 };
      }
      document.removeEventListener('mousemove', this.onDrag);
      document.removeEventListener('mouseup', this.stopDrag);
    },
    handleElementClick(event, bodegaCode) {
      // Solo abrir el modal si no se estaba arrastrando
      if (!this.draggingElementId) {
        this.openModalDetails(bodegaCode);
      }
    }
  },
  mounted() {
    this.getBodegas();
    this.restoreElements();
  },
  beforeUnmount() {
    // Limpiar event listeners al desmontar el componente
    document.removeEventListener('mousemove', this.onDrag);
    document.removeEventListener('mouseup', this.stopDrag);
  }
};
</script>

<style scoped>
.factory-container {
  position: relative;
  width: 100%;
  height: 600px;
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
  border-radius: 8px;
  overflow: hidden;
  border: 2px solid #dee2e6;
}

.factory-section {
  position: absolute;
  border: 2px solid #6c757d;
  cursor: move;
  transition: opacity 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  font-weight: 600;
  text-align: center;
  user-select: none;
  padding: 4px;
}

.factory-section:hover {
  opacity: 0.9;
}

.factory-section.dragging {
  cursor: grabbing;
  opacity: 0.8;
  z-index: 1000;
  transition: none;
}

.factory-section.dynamic {
  min-width: 40px;
  min-height: 40px;
}

.status-occupied {
  box-shadow: 0 0 8px rgba(220, 53, 69, 0.4);
}

.status-available {
  box-shadow: 0 0 8px rgba(40, 167, 69, 0.4);
}

.status-unassigned {
  box-shadow: 0 0 8px rgba(73, 80, 87, 0.2);
}

.legend {
  width: 16px;
  height: 16px;
  border-radius: 3px;
  display: inline-block;
}

.legend-occupied {
  background-color: #dc3545;
}

.legend-available {
  background-color: #28a745;
}

.legend-unassigned {
  border: 1px solid #6c757d;
}
</style>

